/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMathLower = createReactComponent("outline", "math-lower", "IconMathLower", [["path", { "d": "M19 18l-14 -6l14 -6", "key": "svg-0" }]]);

export { IconMathLower as default };
//# sourceMappingURL=IconMathLower.mjs.map
